<template>
  <DashboardHeader>
    <v-content>
      <v-layout row wrap>
        <v-flex v-for="subject in subjects" :key="subject.id+Math.random()" class="rounded-corners">
          <v-card class="mx-auto mb-4 rounded-corners" max-width="250" elevation="22">
            <v-card-subtitle class="pb-0"></v-card-subtitle>

            <v-card-text class="text--primary">
              <div>{{subject.name}}</div>
              <div>{{$route.params.gradeName}}</div>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="var(--theme-color)"
                dark
                rounded
                x-small
                :to="{name:'topics',params:{subjectId:subject.subject_id}}"
              >Browse Subject</v-btn>

              <v-btn
                color="var(--theme-hover-color)"
                dark
                rounded
                x-small
                :to="{name:'dashboard'}"
              >Back To Grades</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-content>
  </DashboardHeader>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader";
import axios from "@/plugins/axios";

export default {
  components: {
    DashboardHeader
  },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    }
  },
  data() {
    return {
      subjects: []
    };
  },
  mounted() {
    this.$store.commit("setLoader", true);
    axios
      .postDataWithToken(
        "/auth/subjects",
        { id: this.$route.params.gradeId },
        this.getAccessToken
      )
      .then(response => {
        this.subjects = response;
        this.$store.commit("setLoader", false);
      });
  }
};
</script>

<style>
.roundedCard {
  border-radius: 30px;
}
</style>
